import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid } from 'react-bootstrap';
import { PasswordReset } from 'react-cognito';
import {
  Router,
  Route,
  Redirect,
  Switch
} from 'react-router-dom';
import createHistory from 'history/createBrowserHistory'
import ReactGA from 'react-ga';

import './App.css';
import PasswordResetForm from './components/Authentication/PasswordResetForm';
import RecruiterLayout from './hoc/layout/RecruiterLayout';
import ClientLayout from './hoc/layout/ClientLayout';
import Account from './components/Authentication/Account';
import Header from './components/Common/Header/Header';
import SimpleLayout from './hoc/layout/SimpleLayout';
import ProfileSettings from './components/Common/ProfileSettingsPage/ProfileSettingsPage';
import Footer from './components/Recruiter/Footer/Footer';
import Intercom from './lib/Intercom';
import Aux from './hoc/Auxi/Auxi';
import config from './config';
import AdminLayout from './hoc/layout/Admin/AdminLayout';
import ComponentList from './container/ComponentList';
import ConsoleLog from './hoc/ConsoleLog/ConsoleLog';

const passwordReset = () => (
  <PasswordReset>
    <PasswordResetForm />
  </PasswordReset>
);
/**
* @desc  interface over the top of all other components in the app
* @version 1.0.1
* @author Jamshith Lakshmikanth
*/

/* 
The following is the React Google analytics code section start point
*/
const history = createHistory()
ReactGA.initialize(config.GAId);
history.listen((location, action) => {
  ReactGA.pageview(location.pathname + location.search);
  // ConsoleLog("GA console: ", location.pathname)
});
/* 
The following is the React Google analytics code section start point
*/


class App extends Component {

  componentWillMount() {

    if(process.env.REACT_APP_STAGE && process.env.REACT_APP_STAGE === 'production'){
      const hotjar = `
      (function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:1009172,hjsv:6};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
      })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
    `;
        const script = document.createElement("script");

        const scriptText = document.createTextNode(hotjar);

        script.appendChild(scriptText);
        document.head.append(script);
    }

  }

  render() {
    const { pool, clientDetails, jobTitleBHID, jobTitle, activeCandidateId } = this.props;
    const currentCandidate = (pool) ? pool.find(e => e.candidate_id === activeCandidateId) : null;
    const RecruiterEmail = (currentCandidate && currentCandidate.recruiter_email) ? currentCandidate.recruiter_email : null;
    const RecruiterName = (currentCandidate && currentCandidate.recruiter_name) ? currentCandidate.recruiter_name : null;
    const currentCandidateId = (currentCandidate && currentCandidate.candidate_source_id) ? currentCandidate.candidate_source_id : null;
    const user = {
      user_id: this.props.clientDetails.user_id,
      email: this.props.clientDetails.user_email,
      name: this.props.clientDetails.user_fname + ' ' + this.props.clientDetails.user_lname,
      RecruiterEmail: RecruiterEmail,
      RecruiterName: RecruiterName,
      JobId: jobTitleBHID,
      JobTitle: jobTitle,
      CandidateId: currentCandidateId,
    };

    return (
      <Router history={history}>
        <Switch>
          <Route exact path="/ui-components" component={ComponentList} />
          <Route exact path="/account" component={Account} />
          <Route exact path="/recruiter/account" component={Account} />
          <Route exact path="/admin/account" component={Account} />
          <Route exact path="/forgot-password" component={passwordReset} />
          <Route exact path="/recruiter/forgot-password" component={passwordReset} />
          <Route exact path="/admin/forgot-password" component={passwordReset} />
          <Route path="/content-pages" render={(props) => (
            <SimpleLayout />
          )} />
          <Route path="/candidateInterview" render={(props) => (
            <SimpleLayout />
          )} />
          <Route path="/recruiter/interview/:id" render={(props) => (
            localStorage.setItem('interviewId', props.match.params.id),
            this.props.state  == 'LOGGED_IN' ? (
              <RecruiterLayout />
            ) : (
              <Redirect exact to="/recruiter/account"/>
            )
          )}/> 
          <Route path="/recruiter" render={(props) => (
            this.props.state == 'LOGGED_IN' ? (
              <RecruiterLayout />
            ) : (
              <Redirect exact to="/recruiter/account"/>
            )
          )}/>
          <Route path="/admin" render={(props) => (
            this.props.state == 'LOGGED_IN' ? (
              <AdminLayout />
            ) : (
                <Redirect exact to="/admin/account" />
              )
          )} />
          <Route path="/profile-settings" render={(props) => (
            this.props.state == 'LOGGED_IN' ? (
              <div className="root recruiter">
                <div className={this.props.groups.includes('admin') ? "app-container adminLayout" : "app-container recruiter"}>
                  <Header />
                  <div className="app-body">
                    <Grid>
                      <ProfileSettings />
                      {(this.props.groups.includes('client') && user.user_id) ?
                        <Intercom appID={config.intercomAppId} {...user} />
                        : null
                      }
                    </Grid>
                  </div>
                  <Footer />
                </div>
              </div>
            ) : (
                <Redirect exact to="/recruiter/account" />
              )
          )} />

          <Route path="/job/:id" render={(props) => (
            localStorage.setItem('jobTitleId', props.match.params.id),
            this.props.state == 'LOGGED_IN' ? (
              <Aux>
                <ClientLayout {...props.match.params} />
                { (this.props.groups.includes('client') && user.user_id) ? <Intercom appID={config.intercomAppId} {...user} /> : null }
              </Aux>
            ) : (
                <Redirect exact to="/account" />
              )
          )} />

          <Route path="/" render={(props) => (
            this.props.state == 'LOGGED_IN' ? (
              <Aux>
                <ClientLayout {...props.match.params} />
                { (this.props.groups.includes('client') && user.user_id) ? <Intercom appID={config.intercomAppId} {...user} /> : null }
              </Aux>
            ) : (
                <Redirect exact to="/account" />
              )
          )} />
        </Switch>
      </Router>
    );
  }
}
/**
* @desc connecting to redux store
* @param state
* @return redux state
*/
const mapStateToProps = state => ({
  state: state.cognito.state,
  user: state.cognito.user,
  attributes: state.cognito.attributes,
  clientDetails: state.clientProfile.clientDetails,
  groups: state.cognito.groups,
  pool: state.talentPool.pool,
  jobTitleId :state.talentPool.jobTitleId,
  activeCandidateId: state.talentPool.activeCandidateId,
  jobTitle: state.talentPool.jobTitle,
  jobTitleBHID: state.talentPool.jobTitleBHID,
});

const reduxConnector = connect(mapStateToProps, null, null, { pure: false });

export default reduxConnector(App);


// WEBPACK FOOTER //
// ./src/App.js